import {
  CLOSE_TIP_SCREEN,
} from '../main/payment/constants';
import { cancelTipping } from '../register/tipping/actions';

const tippingScreenMiddleware = store => next => (action) => {
  switch (action.type) {
    case CLOSE_TIP_SCREEN:
      store.dispatch(cancelTipping());
      break;

    default:
  }

  next(action);
};

export default tippingScreenMiddleware;
